import Vue from 'vue';
import * as html from './footer.html';

export default Vue.extend({
	render: html.render,
	staticRenderFns: html.staticRenderFns,
	components: {}
});
